const KEYS = {
  EVENTS: 'events',
  EVENT_SUMMARY: 'event_summary',
  EVENT_UPCOMING: 'event_upcoming',
  BOOKINGS: 'bookings',
  VERIFY_BOOKING_EVENT: 'verify_booking_event',
  BOOKING_EVENT: 'booking_event',
  BOOKING_EVENT_AVAILABILITY_DATE: 'booking_event_availability_date',
  BOOKING_EVENT_AVAILABILITY_TIME: 'booking_event_availability_time',
  BOOKING_EVENT_AVAILABILITY_DATE_TIME: 'booking_event_availability_date_time',
  LOGS: 'logs',
};

const EVENT_TYPES = {
  BOOKING: 'BOOKING',
  VIDEO: 'VIDEO',
  CALL: 'CALL',
  EVENT: 'EVENT',
};

export default {
  ...KEYS,
  EVENT_TYPES,
};
